import { useFormContext } from "@/modules/forms";
import { faBox, faHome, faStore } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { useState } from "react";

import InlineSelector from "./InlineSelector";
import PanelToggle from "./PanelToggle";
import homeIcon from "@/assets/icons/home.svg";
import storeIcon from "@/assets/icons/store.svg";
import mopedIcon from "@/assets/icons/moped.svg";
import { Divider } from "antd";
//
import styled from "styled-components";
import SectionHeader from "../common/SectionHeader";
export const LOCATION_OPTIONS = [
  {
    label: "Reparatie in de winkel",
    description: "Kom bij ons langs voor je reparatie",
    icon: storeIcon,
    value: "in-store",
    apiValue: "1",
  },
  {
    label: "Reparatie op locatie",
    // @pim fix this description and remove this line once it's done
    description: "Wij komen naar jou!",
    icon: homeIcon,
    value: "home",
    apiValue: "2",
  },

  {
    label: "Haal en breng",
    description: "Lorem ipsum",
    icon: mopedIcon,
    value: "pickup",
    apiValue: "4",
  },
  // {
  //   label: "Opsturen",
  //   description: "Coming soon",
  //   icon: faBox,
  //   disabled: true,
  //   value: "delivery",
  // },
];


export function getLocationOptions(shop) {
  return LOCATION_OPTIONS.map((option) => ({
    ...option,
    disabled: !shop.shop_type?.includes(option.apiValue),
  }));
}

export function getActiveLocationOptions(shop) {
  return LOCATION_OPTIONS.filter((option) =>
    shop.shop_type?.includes(option.apiValue)
  );
}
export default function LocationSelector(props) {
  const { state } = useFormContext();
  const { options, ...rest } = props;
  const [open, setOpen] = useState(props.open || false);
  const selectedLocation = options.find(
    (item) => item.value === state.values.location
  );
  const subHeader = selectedLocation ? selectedLocation.label : "Niet geselecteerd";
  return (
    <PanelToggle
      header={<SectionHeader title="Reparatie type"/>}
      open={open}
      expandable={false}
      onToggle={setOpen}
    >
      <InlineSelector options={options} {...rest} className="inline-selector"/>
    </PanelToggle>
  );
}
